import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { LanguageDeleteService } from '../../services';

export const fetchLanguageDelete = createAsyncThunk(
    'languageDelete/fetchLanguageDelete',
    async ({ id }) => {
        const response = await LanguageDeleteService(id)
        return response.result
    }
)

const languageDeleteSlice = createSlice({
    name: 'languageDelete',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchLanguageDelete.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchLanguageDelete.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchLanguageDelete.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default languageDeleteSlice.reducer;
